import React, { Component } from 'react';
import moment from 'moment';

class MachineTermsView extends Component {
    render() {
        return (
            <div>
                <b>
                    Ubicación:&nbsp;
                </b>
                {this.props.location}
                <br />
                <b>
                    Marca:&nbsp;
                </b>
                {this.props.brand}
                <br />

                <b>
                    Modelo:&nbsp;
                </b>
                {this.props.model}
                <br />

                <b>
                    N/serie:&nbsp;
                </b>
                {this.props.serial}
                <br />

                <b>
                    Año:&nbsp;
                </b>
                {this.props.year}
                <br />
                <b>
                    Ultimo Chequeo:&nbsp;
                </b>
                {moment().add(this.props.lastcheck, 'days').calendar()}
                {/* {moment()} */}
                <br />
            </div>
        );
    }
}

export default MachineTermsView;



// WEBPACK FOOTER //
// ./src/components/views/MachineTermsView.js